import { useTranslation } from "react-i18next";
import { ReactComponent as Success } from "assets/icons/success.svg";
import config from "utils/globals";
import { Button } from "antd";

const Receipt = ({ amount, onStageShow }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col  px-4 py-5 mt-0 bg-white  shadow-lg rounded-lg m-5">
      <div className="w-[60px] h-[60px] table m-auto ">
        <div className="w-[60px] h-[60px] relative flex justify-center items-center">
          <Success className="w-[60px] h-[60px] " />
        </div>
      </div>
      <div className={`text-center text-primary-0 body-16px-medium mb-2`}>
        {t("pma-onboarding.receipt-successful")}
      </div>
      <div className="text-center text-gray-0 body-14px-regular font-normal pb-5 border-b-gray--7 border-b">
        {t("pma-onboarding.complementary-successful")}
      </div>

      <div div className="px-3 py-4 bg-gray--12 rounded-lg my-5 ">
        <div className="flex justify-between flex-wrap items-center">
          <span className="body-14px-regular text-gray-0 ">{t("amount")}</span>
          <span className="flex gap-1 text-gray-4 body-16px-medium ">
            {config.numberSeparator(amount)}
            <span className="body-14px-regular">{t("rial")}</span>
          </span>
        </div>
        {/* <div
          className={`flex gap-1 items-center justify-between caption-12px-medium text-gray-0`}
        >
          <span className="body-14px-regular text-gray-0 ">
            {t("pma-onboarding.transaction-code")}
          </span>
          <span className=" text-gray-4 body-16px-medium">{traceNo}</span>
        </div> */}
      </div>
      <Button
        block
        className={`default-button-large justify-center items-center`}
        onClick={onStageShow}
      >
        {t("close")}
      </Button>
    </div>
  );
};

export default Receipt;
